"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListBodyPagination = void 0;
var React = require("react");
var actions_1 = require("src/actions");
var Pagination_1 = require("Views/Partials/Components/Pagination");
var FilterableListBodyPagination = function (_a) {
    var pageCount = _a.pageCount, pageSize = _a.pageSize, pageNumber = _a.pageNumber, setIsContentLoading = _a.setIsContentLoading;
    var handlePageChange = React.useCallback(function (obj) {
        window.scrollTo(0, 0);
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageChange(obj.selected));
    }, [setIsContentLoading]);
    var handlePageSizeChange = React.useCallback(function (pageSize) {
        setIsContentLoading(true);
        actions_1.ActionsController.dispatch(actions_1.FilterableListActions.pageSizeChange(pageSize));
    }, [setIsContentLoading]);
    return (React.createElement("div", { className: "filterable-list__pagination" },
        React.createElement(Pagination_1.default, { pageCount: pageCount, pageSize: pageSize, onPageChange: handlePageChange, onPageSizeChange: handlePageSizeChange, forcePage: pageNumber })));
};
exports.FilterableListBodyPagination = FilterableListBodyPagination;
